// extracted by mini-css-extract-plugin
export default {"unitText":"Unit_unitText__vasxC"};